import { gql } from '__generated__';

export default gql(`
  mutation ResumeWaitlist($input: ResumeWaitlistInput!) {
    resumeWaitlist(input: $input)
  }
`);
